// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpTreeItem } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const TreeItem = wrap(jpTreeItem(), {
    events: { onExpand: 'expanded-change', onSelect: 'selected-change' }
});
// @ts-expect-error unknown property
TreeItem.displayName = 'Jupyter.TreeItem';
